import * as React from "react";
import "../App.css";
import Appbar from "../component/appbar";
import Foot from "../component/foot";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

let aws = '';

function Button_click() {
  alert(aws);
}

function Page2() {
  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    aws = event.target.value;
    setAge(event.target.value);
  };
  return (
    <div className="App">
      <Appbar />
      <header className="App-header">
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            py: 7,
          }}
        >
          <Card sx={{ maxWidth: 500, m: 3 }}>
            <CardMedia
              sx={{ height: 200 }}
              image="https://th.bing.com/th/id/R.e6ac556d4ff7969dda32a82307fb372f?rik=Z6Q79yn3%2bo3OBA&riu=http%3a%2f%2fupload.wikimedia.org%2fwikipedia%2fcommons%2f2%2f25%2fBangkok_Reptiles_Blue_crested_Lizard.jpg&ehk=OjGCdLaNX8IsxLidsQ0JYE5oDfXMb4Lbd1L6rtt3Ahc%3d&risl=&pid=ImgRaw&r=0"
              title="green iguana"
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Lizard
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                <Box sx={{ minWidth: 400 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Age</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={age}
                      label="Age"
                      onChange={handleChange}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                color="secondary"
                onClick={Button_click}
              >
                Submit
              </Button>
            </CardActions>
          </Card>
        </Box>
        <p>{age}</p>
      </header>
      <Foot />
    </div>
  );
}

export default Page2;